import PoIndex from "@/components/flux_oms/po/PoIndex.vue";
import PoUpload from "@/components/flux_oms/po/PoUpload.vue";
import PoCreate from "@/components/flux_oms/po/PoCreate.vue";
import PoDetail from "@/components/flux_oms/po/PoDetail.vue";
import PoUpdate from "@/components/flux_oms/po/PoUpdate.vue";

let routesPo= [
    {
        path: '',
        meta: {
            title: "PO (Inbound)",
        },
        name: "PoIndex",
        component: PoIndex
    },
    {
        path: 'create',
        meta: {
          title: "PO (Inbound) Create",
        },
        name: "PoCreate",
        component: PoCreate
    },

    {
        path: 'upload',
        meta: {
          title: "PO (Inbound)",
        },
        name: "PoUploads",
        component: PoUpload
    },

    {
        path: 'detail/:id',
        meta: {
          title: "PO (Inbound) Detail",
        },
        name: "PoDetail",
        component: PoDetail
    },


    {
      path: 'edit/:id',
      meta: {
        title: "PO (Inbound) Update",
      },
      name: "PoUpdate",
      component: PoUpdate
  },
     
   
     
    // {
    //     path: 'edit/:id',
    //     meta: {
    //       title: "Master SKU Edit",
    //     },
    //     name: "MasterSKUEdit",
    //     component: MasterSKUEdit
    // },
    
]

export default routesPo
  